import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, IconButton } from '@material-ui/core';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import EditIcon from '@material-ui/icons/Edit';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';
import CustomForm from '../../../components/FormRenderer/CustomForm';

import {
  sanitizePayload,
  initializeFormData,
} from '../../../components/FormRenderer/utils';
import {
  getSchoolStaffs,
  addUserToSchool,
  updateBuzzOneUser,
} from '../BuzzOneSlice';
import moment from 'moment';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';

export default function BuzzOneSchoolStaffs() {
  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();
  const { handleLoader } = useLoader();

  const [showFormModal, setFormModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [formTemplate, setFormTemplate] = useState(null);
  const [formData, setFormData] = useState({});

  const { schools, staffs } = useSelector(({ buzzOne }) => {
    return {
      schools: buzzOne.schools,
      staffs: buzzOne.staffs,
    };
  });

  const [schoolId, setSchoolId] = useState();

  useEffect(() => {
    if (!schoolId) return;
    dispatch(getSchoolStaffs({ schoolId }));
  }, [schoolId]);

  useEffect(() => {
    if (!schools || schools.length === 0) return;
    setSchoolId(schools[0]._id);
  }, [schools]);

  useEffect(() => {
    if (selectedRowId) {
      let newFormData = JSON.parse(
        JSON.stringify(staffs.filter((item) => item._id === selectedRowId)[0])
      );

      setFormData(newFormData);
    } else setFormData(initializeFormData(formTemplate));
  }, [selectedRowId]);

  useEffect(() => {
    const formTemplate = [
      {
        id: 'form.name',
        title: 'Name',
        slug: 'name',
        type: 'String',
        required: true,
      },

      {
        id: 'form.email',
        title: 'Email Id',
        slug: 'email',
        type: 'String',
        required: true,
      },
      {
        id: 'form.mobile',
        title: 'Mobile',
        slug: 'mobile',
        type: 'String',
        required: true,
      },
    ];
    setFormTemplate(formTemplate);

    setFormData(initializeFormData(formTemplate));
  }, []);

  const staffsColumn = [
    { Header: 'Staff Id', accessor: 'staffNumber' },
    { Header: 'Name', accessor: 'name' },
    {
      Header: 'PII',
      Cell: (val) => {
        return (
          <>
            <p>{val.cell.row.original.email}</p>
            <p>{val.cell.row.original.mobile}</p>
          </>
        );
      },
    },
    {
      Header: 'Roles',
      Cell: (val) => {
        return (
          <>
            {val.cell.row.original.scopes
              .filter(({ school }) => school._id === schoolId)
              .map(({ role, product }) => (
                <p>
                  {role} - {product}
                </p>
              ))}
          </>
        );
      },
    },
    {
      Header: 'Action',
      Cell: (val) => {
        const { _id } = val.cell.row.original;

        return (
          <>
            <IconButton onClick={() => handleEdit(_id)}>
              <EditIcon color="secondary" />
            </IconButton>
          </>
        );
      },
    },
  ];

  const openFormModal = () => setFormModal(true);
  const closeFormModal = () => setFormModal(false);

  const handleEdit = (id) => {
    setSelectedRowId(id);
    openFormModal();
  };

  const handleCreateNew = () => {
    setSelectedRowId(null);
    openFormModal();
  };

  const handleSave = async () => {
    handleLoader(true);
    let payload = sanitizePayload(formData);

    dispatch(
      selectedRowId === null
        ? addUserToSchool({ schoolId, data: payload })
        : updateBuzzOneUser({ id: selectedRowId, data: payload })
    )
      .unwrap()
      .then((res) => {
        SuccessToast(res.message);
        dispatch(getSchoolStaffs({ schoolId }));
        closeFormModal();
      })
      .catch((error) => {
        console.error('rejected', error);
        ErrorToast(error.message);
      });

    handleLoader(false);
  };

  return (
    <Box style={{ width: '100%' }}>
      <Box
        display="flex"
        alignItems={'center'}
        justifyContent={'space-between'}
        style={{ gap: '1rem', width: '100%' }}>
        <div>
          <Button
            onClick={handleCreateNew}
            variant={'contained'}
            color="primary">
            Add Staff
          </Button>
        </div>

        <div style={{ minWidth: '20%' }}>
          <BuzzSelect
            // fullWidth={false}
            name="School"
            size={'small'}
            placeholder={'Select School'}
            value={schoolId}
            onChange={(e) => {
              setSchoolId(e.target.value);
            }}
            // label="Select Type"
            valueKey="_id"
            labelKey="name"
            options={schools}
          />
        </div>
      </Box>

      <Box my={2}>
        <BuzzTable
          columns={staffsColumn}
          data={staffs}
          isHandlePagination={true}
        />
      </Box>
      <Modal open={showFormModal} onClose={closeFormModal}>
        <CustomForm
          formFor={'Staff'}
          formTemplate={formTemplate}
          formData={formData}
          setFormData={(slug, newValue) => {
            setFormData((state) => {
              state[slug] = newValue;
              return state;
            });
            setFormTemplate((state) => {
              return JSON.parse(JSON.stringify(state));
            });
          }}
          mode={selectedRowId === null ? 'CREATE' : 'EDIT'}
          handleSave={handleSave}
        />
      </Modal>
    </Box>
  );
}
